/** Hızlı teklif simgeleri: taslaktaki çizgi simge seti (24 kutu, 1,5 çizgi). Süs simgesi yok; yalnız işlev. */
import type { ReactNode } from 'react';

const YOLLAR: Readonly<Record<string, ReactNode>> = {
  ara: <><circle cx="11" cy="11" r="6.5" /><path d="m20 20-4.2-4.2" /></>,
  bilgi: <><circle cx="12" cy="12" r="8.5" /><path d="M12 11v5M12 8v.1" /></>,
  saat: <><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 2" /></>,
  kisi: <><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" /></>,
  yildiz: <path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.3 6.1 20.5l1.2-6.5L2.5 9.4l6.6-.9L12 2.5Z" />,
  kalkan: <><path d="M12 3 5 6v5.5c0 4.4 2.9 7.7 7 9.5 4.1-1.8 7-5.1 7-9.5V6l-7-3Z" /><path d="m9 12 2.2 2.2L15.5 10" /></>,
  uyari: <><path d="M12 4 2.8 19.5h18.4L12 4Z" /><path d="M12 10v4.5M12 17.2v.1" /></>,
  indir: <path d="M12 4v11M7 11l5 5 5-5M5 20h14" />,
  arti: <path d="M12 5v14M5 12h14" />,
  eksi: <path d="M5 12h14" />,
  yenile: <path d="M20 11a8 8 0 0 0-14.5-3.5L4 9.5M4 4.5v5h5M4 13a8 8 0 0 0 14.5 3.5l1.5-2M20 19.5v-5h-5" />,
  yatak: <><path d="M3 18V6M3 14h18v4M21 14v-2.5A2.5 2.5 0 0 0 18.5 9H11v5" /><circle cx="7" cy="11" r="1.7" /></>,
  mesaj: <><path d="M4 5h16v11H9l-5 4z" /><path d="M8 9.5h8M8 12.5h5" /></>,
  fincan: <><path d="M4 8h13v6a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V8Z" /><path d="M17 9.5h1.5a2.5 2.5 0 0 1 0 5H17M8 3.5v2M12 3.5v2" /></>,
  belge: <><path d="M6 3h8l4 4v14H6z" /><path d="M14 3v4h4M9 12h6M9 16h6" /></>,
  kapat: <path d="M6 6l12 12M18 6 6 18" />,
  tik: <path d="m5 12.5 4.5 4.5L19 7.5" />,
  takvim: <><rect x="3.5" y="5" width="17" height="15.5" rx="2" /><path d="M3.5 10h17M8 3v4M16 3v4" /></>,
  kilit: <><rect x="5" y="10.5" width="14" height="9.5" rx="2" /><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" /></>,
  duzenle: <><path d="M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17z" /><path d="m14 8 3 3" /></>,
  kopya: <><rect x="8.5" y="8.5" width="12" height="12" rx="2" /><path d="M15.5 8.5V5a1.5 1.5 0 0 0-1.5-1.5H5A1.5 1.5 0 0 0 3.5 5v9A1.5 1.5 0 0 0 5 15.5h3.5" /></>,
};

export type IkonAdi = keyof typeof YOLLAR;

export function Ikon({ ad, kucuk = false }: { ad: IkonAdi; kucuk?: boolean }) {
  return (
    <svg className={`ht-ik${kucuk ? ' ht-ik-k' : ''}`} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {YOLLAR[ad]}
    </svg>
  );
}

/** Yıldız sırası (otel sınıfı): dolu yıldız yalnız derecelendirme göstergesi, süs değil. */
export function Yildizlar({ n }: { n: number }) {
  if (!Number.isFinite(n) || n < 1) return null;
  return (
    <span className="ht-yildizlar" role="img" aria-label={`${n} yıldız`}>
      {Array.from({ length: Math.min(5, Math.round(n)) }, (_, i) => <Ikon key={i} ad="yildiz" kucuk />)}
    </span>
  );
}
